/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useFieldArray, useForm, Controller, useWatch } from "react-hook-form";
import {
  Flex,
  Button,
  FormControl,
  FormLabel,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import FormInput from "components/forms/form-Input";
import NumericInput from "components/forms/react-hook-numeric-input";
import { useLookupCurrencyMultiples } from "services/lookups-mutations";
import ReactHookFormDropdown from "components/forms/react-hook-dropdown";

const CASSETTES_DEFAULT = {
  description: "",
  denomination: "Multiple",
  currency: "",
  multiple: "",
  cassetteType: "",
  maker: "",
  limit: 0,
  dualScanning: true,
};
const CASSETTES_DESCRIPTIONS = [
  {
    id: "ATM Cassette",
    text: "ATM Cassette",
  },
  {
    id: "CDM Cassette",
    text: "CDM Cassette",
  },
  {
    id: "ATM Reject Bin",
    text: "ATM Reject Bin",
  },
  {
    id: "CDM Cash Bin",
    text: "CDM Cash Bin",
  },
];
const CASSETTES_TYPE = [
  {
    value: "Type 1",
    label: "Type 1",
  },
  {
    value: "Type 2",
    label: "Type 2",
  },
  {
    value: "Type 3",
    label: "Type 3",
  },
  {
    value: "Type 4",
    label: "Type 4",
  },
  {
    value: "Type 5",
    label: "Type 5",
  },
  {
    value: "Type 6",
    label: "Type 6",
  },
  {
    value: "Cash Bin",
    label: "Cash Bin",
  },
  {
    value: "Reject Bin",
    label: "Reject Bin",
  },
];
export const isDenominationMixed = (description) => {
  if (description === "ATM Cassette" || description === "CDM Cassette")
    return false;
  return true;
};

export default function CassettesForm({
  addData,
  cassettes,
  currencies,
  disabled,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    mutate: getMultiples,
    data: multipleList,
    reset: cassetteMultipleReset,
  } = useLookupCurrencyMultiples();

  const {
    handleSubmit,
    getValues,
    watch,
    control,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...CASSETTES_DEFAULT,
      cassettes: [...cassettes],
    },
  });
  const generalFieldProps = { control, errors };
  const selectedCurrency = useWatch({ control, name: "currency" });
  const formValidationRules = {
    description: { required: "Please add description" },
    denomination: { required: "Please add denomination" },
    cassetteType: { required: "Please select cassette type" },
    maker: { required: "Please add maker" },
    limit: {
      validate: (value) => {
        if (
          (!isDenominationMixed(watch("description")) && !value) ||
          value === "0"
        ) {
          return "Please Enter Limit";
        }
        return true;
      },
    },
  };
  const { fields: cassettesFields, remove: cassettesFieldsRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "cassettes",
    });
  useEffect(() => {
    if (addData) addData([...cassettesFields]);
  }, [cassettesFields]);

  useEffect(() => {
  cassetteMultipleReset();
  const currencyValue =
    typeof selectedCurrency === "string"
      ? selectedCurrency
      : selectedCurrency?.value;

  if (currencyValue) {
    getMultiples(currencyValue);
  }
}, [selectedCurrency]);

  useEffect(() => {
    if (watch("multiple")) {
      const currencyValue = watch("currency");
      setValue("denomination", `${currencyValue || ""} ${watch("multiple") || ""}`);
      clearErrors("denomination");
    }
  }, [watch("multiple")]);

  const onCurrencyDescriptionChange = (_value) => {
    setValue("currency", "");
    setValue("multiple", "");
    if (!isDenominationMixed(_value)) {
      setValue("denomination", "");
    } else {
      setValue("limit", 0);
      setValue("denomination", "Mixed");
      if (_value === "ATM Reject Bin") {
        setValue("cassetteType", { value: "Reject Bin", label: "Reject Bin" });
      } else if (_value === "CDM Cash Bin") {
        setValue("cassetteType", { value: "Cash Bin", label: "Cash Bin" });
      }
    }
  };
  const onCurrencyChange = () => {
    cassetteMultipleReset();
    setValue("multiple", "");
  };
  const submitInfo = (data) => {
    const _cassettes = [...cassettesFields];
    const newCassette = {
      description: data.description,
      denomination: data.denomination,
      currency: data.currency,
      multiple: data.multiple,
      cassetteType: data.cassetteType,
      maker: data.maker,
      limit: data.limit,
      dualScanning: data.dualScanning,
    };
    if (currentEditing !== null) {
      _cassettes[currentEditing] = newCassette;
      setCurrentEditing(null);
    } else {
      _cassettes.push(newCassette);
    }
    reset({
      ...CASSETTES_DEFAULT,
      cassettes: [..._cassettes],
    });
  };

  const editCell = ({ dataItem, dataIndex }) => {
  return (
    <td>
      <Flex
        title="Edit Cassette"
        cursor="pointer"
        onClick={() => {
          const {
            ...rest
          } = dataItem;

          reset({
            ...getValues(),
            ...rest,
            cassettes: [...cassettesFields],
          });

          setCurrentEditing(dataIndex);
        }}
      >
        <FaEdit fontSize="18px" color="var(--primary-dark)" />
      </Flex>
    </td>
  );
};


  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Cassette"
          cursor="pointer"
          onClick={() => {
            cassettesFieldsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...CASSETTES_DEFAULT,
      cassettes: [...cassettesFields],
    });
    setCurrentEditing(null);
  };

  return (
    <form>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Description"
        name="description"
        data={
          CASSETTES_DESCRIPTIONS.map((desc) => ({
            value: desc.id,
            label: desc.text,
          })) || []
        }
        placeholder="Select Description"
        rules={formValidationRules.description}
        onChange={onCurrencyDescriptionChange}
        disabled={disabled}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="currency"
        data={
          currencies?.map((currency) => ({
            value: currency.shortName,
            label: currency.name,
          })) || []
        }
        placeholder="Select Currency"
        rules={formValidationRules.currency}
        onChange={onCurrencyChange}
        dropdownProps={{ filterable: true }}
        disabled={disabled || isDenominationMixed(watch("description"))}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiple"
        name="multiple"
        data={
          multipleList?.data.map((elm) => ({
            value: elm.multiple.toString(),
            label: elm.multiple.toString(),
          })) || []
        }
        placeholder="Select Multiple"
        rules={formValidationRules.multiple}
        disabled={
          disabled ||
          !watch("currency") ||
          isDenominationMixed(watch("description"))
        }
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        name="denomination"
        label="Denomination"
        rules={formValidationRules.denomination}
        readOnly
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Cassette Type"
        name="cassetteType"
        data={CASSETTES_TYPE}
        placeholder="Select Cassette Type"
        rules={formValidationRules.cassetteType}
        dropdownProps={{ filterable: false }}
        disabled={disabled || isDenominationMixed(watch("description"))}
      />

      <FormInput
        {...generalFieldProps}
        isRequired
        label="Maker"
        rules={formValidationRules.maker}
        name="maker"
        disabled={disabled}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Limit"
        rules={formValidationRules.limit}
        name="limit"
        disabled={disabled}
      />

      <div style={{ width: "100%" }} />
      <FormControl>
        <Controller
          control={generalFieldProps.control}
          name="dualScanning"
          render={({ field }) => {
            return (
              <Checkbox
                isChecked={field.value}
                onChange={field.onChange}
                disabled={disabled}
              >
                <FormLabel style={{ margin: 0 }}>Dual Scanning</FormLabel>
              </Checkbox>
            );
          }}
        />
      </FormControl>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing} disabled={disabled}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button
          type="button"
          disabled={disabled}
          onClick={handleSubmit(submitInfo)}
        >
          {currentEditing !== null ? "Update Cassette" : "Add Cassette"}
        </Button>
      </div>
      <div style={{ width: "100%" }} />

      <Grid data={cassettesFields} style={{ width: "100%" }}>
        <GridColumn field="description" title="Description" />
        <GridColumn Title="Denomination" field="denomination" />
        <GridColumn title="Cassette type" field="cassetteType" />
        <GridColumn title="Maker" field="maker" />
        <GridColumn title="Limit" field="limit" />
        <GridColumn
          title="Dual Scanning"
          cell={({ dataItem }) => (
            <td>
              <Checkbox isChecked={dataItem.dualScanning} />
            </td>
          )}
        />
        <GridColumn title="Edit" cell={editCell} width={120} />
        <GridColumn title="Delete" cell={deleteCell} width={120} />
      </Grid>
    </form>
  );
}
